<template>
  <div class="content">
    <card>
      <h4 slot="header" class="card-title">Serviço: Projeto e homologação</h4>
      <form>
        <div class="row pl-2">
          <div class="col-md-4">
            <label for="estado">Selecione seu estado</label>
            <select v-model="estado" class="form-control">
              <option
                v-for="option in estados"
                :value="option"
                :label="option"
                :key="option"
              ></option>
            </select>
          </div>
          <div class="col-md-4">
            <label for="estado">Selecione o tamanho do seu sistema</label>
            <select v-model="sistemaSelecionado" class="form-control">
              <option
                v-for="option in tamanhoDoSistemaOptions"
                :value="option"
                :label="option.label"
                :key="option.value"
              ></option>
            </select>
          </div>
        </div>

        <div class="row"></div>
        <div class="text-center">
          <button
            class="btn btn-info btn-fill float-left"
            @click.prevent="calcularProjetoHomologacao"
          >
            Calcular
          </button>
        </div>

        <div class="clearfix"></div>
      </form>
      <card v-if="isCalculated" class="card-user mt-2">
        <div style="text-align: center">
          <h4 class="title">Detalhes:</h4>

          <div v-if="isNordeste && !isCombinar">
            <h5>Prazo Concessionária:{{ prazos.concessionariaHomologacao }}</h5>
            <h5>
              Prazo Joule Recebimento informações:
              {{ prazos.jouleHomologacaoRecebimento }}
            </h5>
            <h5>
              Prazo Joule Emissão TRT/ART: {{ prazos.jouleHomologacaoTrtArt }}
            </h5>
            <h5>Conclusão do projeto: {{ prazos.jouleHomologacao }}</h5>
            <h5>Valor Total: R${{ prazos.valorTotal }},00</h5>
            <div>
              <div class="form-group">
                <label>Observações</label>
                <textarea
                  rows="5"
                  class="form-control border-input"
                  placeholder="Observações"
                  v-model="observacao"
                ></textarea>
                <base-input
                  class="text-left col-md-2 pt-2 pl-0"
                  type="text"
                  placeholder="UC"
                  v-model="ucProjetoHomologacao"
                ></base-input>
              </div>
            </div>
            <div class="row pl-3 pb-3 align-items-center">
              <button
                id="upload_widget"
                class="d-inline"
                @click.prevent="uploadImage(0)"
                v-if="!attachments[0]"
              >
                Selecionar arquivo
              </button>
              <div class="d-inline align-self-center" v-if="attachments[0]">
                <img :src="attachments[0]" alt="anexo" id="attachment" />
                <button
                  class="btn btn-icon btn-danger ml-2"
                  @click.prevent="deleteAttachment(0)"
                >
                  <i class="fa fa-trash-o"></i>
                </button>
              </div>
            </div>
            <button
              class="btn btn-info btn-fill"
              @click.prevent="solicitarServico(0)"
            >
              Contatar
            </button>
          </div>
          <div v-if="!isNordeste">
            <h3>Infelizmente ainda não atuamos em sua área.</h3>
          </div>
          <div v-if="isCombinar && isNordeste">
            <h5>
              Para esta potência o valor é combinado, clique no botão abaixo e
              entraremos em contato.
            </h5>
            <div>
              <div class="form-group">
                <label>Observações</label>
                <textarea
                  rows="5"
                  class="form-control border-input"
                  placeholder="Observações"
                  v-model="observacao"
                ></textarea>
                <base-input
                  class="text-left col-md-2 pt-2 pl-0"
                  type="text"
                  placeholder="UC"
                  v-model="ucProjetoHomologacao"
                ></base-input>
              </div>
            </div>
            <div class="row pl-3 pb-3 align-items-center">
              <button
                id="upload_widget"
                class="d-inline"
                @click.prevent="uploadImage(0)"
                v-if="!attachments[0]"
              >
                Selecionar arquivo
              </button>
              <div class="d-inline align-self-center" v-if="attachments[0]">
                <img :src="attachments[0]" alt="anexo" id="attachment" />
                <button
                  class="btn btn-icon btn-danger ml-2"
                  @click.prevent="deleteAttachment(0)"
                >
                  <i class="fa fa-trash-o"></i>
                </button>
              </div>
            </div>
            <button
              class="btn btn-info btn-fill"
              @click.prevent="solicitarServico(0)"
            >
              Contatar
            </button>
          </div>
        </div>
      </card>
    </card>

    <card>
      <h4 slot="header" class="card-title">Serviço: Execução de obra</h4>
      <form>
        <div class="row pl-2">
          <div class="col-md-4">
            <label for="estado">Selecione seu estado:</label>
            <select v-model="estado2" class="form-control">
              <option
                v-for="option in estados2"
                :value="option"
                :label="option"
                :key="option"
              ></option>
            </select>
          </div>
          <div class="col-md-4">
            <base-input
              type="number"
              label="Potência do sistema em kWp"
              placeholder="Potência kWp"
              v-model="execucao.potenciaExecucao"
            ></base-input>
          </div>
          <div class="col-md-4">
            <base-input
              type="number"
              label="Distância da obra até a Joule em Km"
              placeholder="Distância Km"
              v-model="execucao.distanciaJoule"
            ></base-input>
          </div>
        </div>

        <div class="row"></div>
        <div class="text-center">
          <button
            class="btn btn-info btn-fill float-left"
            @click.prevent="calcularProjetoExecucao"
          >
            Calcular
          </button>
        </div>

        <div class="clearfix"></div>
      </form>
      <card v-if="isCalculated2" class="card-user mt-2">
        <div style="text-align: center">
          <h4 class="title">Detalhes:</h4>

          <div v-if="!isCombinar2">
            <h5>Prazo Joule Execução de Obra: {{ execucao.prazo }} Dias</h5>
            <h5>Valor Total: R${{ execucao.valorTotal }}</h5>
            <div>
              <div class="form-group">
                <label>Observações</label>
                <textarea
                  rows="5"
                  class="form-control border-input"
                  placeholder="Observações"
                  v-model="observacao"
                ></textarea>
                <base-input
                  class="text-left col-md-2 pt-2 pl-0"
                  type="text"
                  placeholder="UC"
                  v-model="execucao.uc"
                ></base-input>
              </div>
            </div>
            <div class="row pl-3 pb-3 align-items-center">
              <button
                id="upload_widget"
                class="d-inline"
                @click.prevent="uploadImage(1)"
                v-if="!attachments[1]"
              >
                Selecionar arquivo
              </button>
              <div class="d-inline align-self-center" v-if="attachments[1]">
                <img :src="attachments[1]" alt="anexo" id="attachment" />
                <button
                  class="btn btn-icon btn-danger ml-2"
                  @click.prevent="deleteAttachment(1)"
                >
                  <i class="fa fa-trash-o"></i>
                </button>
              </div>
            </div>
            <button
              class="btn btn-info btn-fill"
              @click.prevent="solicitarServico(1)"
            >
              Contatar
            </button>
          </div>
          <div v-if="isCombinar2">
            <h5>
              Para esta potência o valor é combinado, clique no botão abaixo e
              entraremos em contato.
            </h5>
            <div>
              <div class="form-group">
                <label>Observações</label>
                <textarea
                  rows="5"
                  class="form-control border-input"
                  placeholder="Observações"
                  v-model="observacao"
                ></textarea>
                <base-input
                  class="text-left col-md-2 pt-2 pl-0"
                  type="text"
                  placeholder="UC"
                  v-model="execucao.uc"
                ></base-input>
              </div>
            </div>
            <div class="row pl-3 pb-3 align-items-center">
              <button
                id="upload_widget"
                class="d-inline"
                @click.prevent="uploadImage(1)"
                v-if="!attachments[1]"
              >
                Selecionar arquivo
              </button>
              <div class="d-inline align-self-center" v-if="attachments[1]">
                <img :src="attachments[1]" alt="anexo" id="attachment" />
                <button
                  class="btn btn-icon btn-danger ml-2"
                  @click.prevent="deleteAttachment(1)"
                >
                  <i class="fa fa-trash-o"></i>
                </button>
              </div>
            </div>
            <button
              class="btn btn-info btn-fill"
              @click.prevent="solicitarServico(1)"
            >
              Contatar
            </button>
          </div>
        </div>
      </card>
    </card>

    <card>
      <h4 slot="header" class="card-title">Serviço: Consultoria</h4>
      <h5 slot="header" class="card-title">Preço: R$400,00 por hora</h5>
      <form>
        <div class="row pl-2">
          <div class="col-md-3">
            <base-radio
              v-model="consultoria.videoConferencia"
              label="conferencia"
              name="tipoConsultoria"
              @change="radioBtnConsultoria"
              @input="radioBtnConsultoria"
              >Vídeo Conferência</base-radio
            >
          </div>
          <div class="col-md-3">
            <base-radio
              v-model="consultoria.vouJoule"
              label="vouJoule"
              name="tipoConsultoria"
              @change="radioBtnConsultoria"
              @input="radioBtnConsultoria"
              >Vou Até a Joule</base-radio
            >
          </div>
          <div class="col-md-3">
            <base-radio
              v-model="consultoria.consultor"
              label="consultor"
              name="tipoConsultoria"
              @change="radioBtnConsultoria"
              @input="radioBtnConsultoria"
              >Consultor vem até mim</base-radio
            >
          </div>
        </div>

        <div>
          <div class="form-group">
            <label>Observações</label>
            <textarea
              rows="5"
              class="form-control border-input"
              placeholder="Observações"
              v-model="observacao"
            ></textarea>
            <base-input
              class="text-left col-md-2 pt-2 pl-0"
              type="text"
              placeholder="UC"
              v-model="consultoria.uc"
            ></base-input>
          </div>
        </div>
        <div class="row pl-3 pb-3 align-items-center">
          <button
            id="upload_widget"
            class="d-inline"
            @click.prevent="uploadImage(2)"
            v-if="!attachments[2]"
          >
            Selecionar arquivo
          </button>
          <div class="d-inline align-self-center" v-if="attachments[2]">
            <img :src="attachments[2]" alt="anexo" id="attachment" />
            <button
              class="btn btn-icon btn-danger ml-2"
              @click.prevent="deleteAttachment(2)"
            >
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
        </div>
        <div class="text-center">
          <button
            class="btn btn-info btn-fill float-left"
            @click.prevent="solicitarServico(2)"
          >
            Contatar
          </button>
        </div>

        <div class="clearfix"></div>
      </form>
    </card>
  </div>
</template>
<script>
import _ from 'lodash';
import Card from 'src/components/Cards/Card.vue';
import LTable from 'src/components/Table.vue';
import Services from 'src/services/servicos';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card,
    LTable
  },
  data() {
    return {
      consultoria: {
        videoConferencia: '',
        vouJoule: '',
        consultor: '',
        uc: ''
      },
      execucao: {
        potenciaExecucao: '',
        distanciaJoule: '',
        valorTotal: 0,
        diasExecucao: [3, 5, 10, 25, 45],
        prazo: '',
        uc: ''
      },

      estado: '',
      estado2: '',
      estados: [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE'
      ],
      estados2: ['AL', 'BA', 'CE', 'MA', 'PB', 'PE', 'PI', 'RN', 'SE'],
      prazos: {
        concessionariaHomologacao: '',
        jouleHomologacao: '',
        jouleHomologacaoRecebimento: '1 Dia',
        jouleHomologacaoTrtArt: '2 Dias',
        valorTotal: '',
        observacao: ''
      },
      sistemaSelecionado: '',
      tamanhoDoSistemaOptions: [
        { label: 'Até 5 kWp', value: 800 },
        { label: '5,1 até 30 kWp', value: 1000 },
        { label: '30,1 até 60 kWp', value: 2000 },
        { label: '60,1 até 110,00', value: 5000 },
        { label: '110,1 até 200 kWp', value: 6000 },
        { label: '200,1 até 300 kWp', value: 7000 },
        { label: 'Maior que 300 kWp', value: 'A combinar' }
      ],
      isCalculated: false,
      isCalculated2: false,
      isCalculated3: false,
      isCombinar: false,
      isCombinar2: false,
      isNordeste: true,
      valorTotal: '',
      servicoSelecionado: {},
      attachments: [0, 0, 0],
      observacao: '',
      ucProjetoHomologacao: ''
    };
  },
  methods: {
    radioBtnConsultoria() {
      this.servicoSelecionado = {};
      this.servicoSelecionado.tipo = 'Consultoria';
      if (this.consultoria.videoConferencia === 'conferencia') {
        this.consultoria.vouJoule = '';
        this.consultoria.consultor = '';
        this.servicoSelecionado.mensagem = 'Através de video conferência';
      } else if (this.consultoria.vouJoule === 'vouJoule') {
        this.consultoria.videoConferencia = '';
        this.consultoria.consultor = '';
        this.servicoSelecionado.mensagem = 'Usuário irá até a Joule';
      } else if (this.consultoria.consultor) {
        this.consultoria.videoConferencia = '';
        this.consultoria.vouJoule = '';
        this.servicoSelecionado.mensagem =
          'Usuário solicita que o consultor vá até ele';
      }
      this.consultoria.videoConferencia = '';
      this.consultoria.vouJoule = '';
      this.consultoria.consultor = '';
      this.observacao = '';
    },
    calcularProjetoHomologacao() {
      this.isCalculated = true;
      this.observacao = '';
      this.servicoSelecionado = {};
      this.servicoSelecionado.tipo = 'Projeto Homologação';
      if (
        this.estado === 'AL' ||
        this.estado === 'BA' ||
        this.estado === 'CE' ||
        this.estado === 'PB' ||
        this.estado === 'PI' ||
        this.estado === 'RN' ||
        this.estado === 'SE'
      ) {
        this.prazos.valorTotal =
          this.sistemaSelecionado.value === 'A combinar'
            ? this.sistemaSelecionado.value
            : this.sistemaSelecionado.value + 500;
        this.isNordeste = true;
      } else if (this.estado === 'PE') {
        this.prazos.valorTotal = this.sistemaSelecionado.value;
        this.isNordeste = true;
      } else {
        this.isNordeste = false;
      }

      if (this.sistemaSelecionado.value < 5000) {
        this.prazos.concessionariaHomologacao = '20 Dias';
        this.prazos.jouleHomologacao = '5 Dias';
        this.isCombinar = false;
      } else if (this.sistemaSelecionado.value === 'A combinar') {
        this.isCombinar = true;
      } else {
        this.prazos.concessionariaHomologacao = '30 Dias';
        this.prazos.jouleHomologacao = '10 Dias';
        this.isCombinar = false;
      }
      if (!this.isCombinar) {
        this.servicoSelecionado.valorTotal = this.prazos.valorTotal;
        this.servicoSelecionado.estado = this.estado;
        this.servicoSelecionado.mensagem = 'Contato do responsável';
      } else {
        this.servicoSelecionado.estado = this.estado;
        this.servicoSelecionado.mensagem = 'Contato do responsável';
      }
    },

    calcularProjetoExecucao() {
      this.isCalculated2 = true;
      this.observacao = '';
      this.servicoSelecionado = {};
      this.servicoSelecionado.tipo = 'Execução de Obra';

      this.execucao.valorTotal = Number(this.execucao.potenciaExecucao) * 303;
      if (Number(this.execucao.distanciaJoule) > 60) {
        this.execucao.valorTotal += Number(
          ((Number(this.execucao.distanciaJoule) - 60) * 1.6).toFixed(2)
        );
      }

      if (this.execucao.potenciaExecucao < 3) {
        this.isCombinar2 = false;
        this.execucao.valorTotal += Number(
          (this.execucao.diasExecucao[0] * 260).toFixed(2)
        );
        this.execucao.prazo = this.execucao.diasExecucao[0];
      } else if (
        this.execucao.potenciaExecucao > 3 &&
        this.execucao.potenciaExecucao <= 20
      ) {
        this.isCombinar2 = false;
        this.execucao.valorTotal += Number(
          (this.execucao.diasExecucao[1] * 260).toFixed(2)
        );
        this.execucao.prazo = this.execucao.diasExecucao[1];
      } else if (
        this.execucao.potenciaExecucao > 20 &&
        this.execucao.potenciaExecucao <= 40
      ) {
        this.isCombinar2 = false;
        this.execucao.valorTotal += Number(
          (this.execucao.diasExecucao[2] * 390).toFixed(2)
        );
        this.execucao.prazo = this.execucao.diasExecucao[2];
      } else if (
        this.execucao.potenciaExecucao > 40 &&
        this.execucao.potenciaExecucao <= 100
      ) {
        this.isCombinar2 = false;
        this.execucao.valorTotal += Number(
          (this.execucao.diasExecucao[3] * 390).toFixed(2)
        );
        this.execucao.prazo = this.execucao.diasExecucao[3];
      } else if (
        this.execucao.potenciaExecucao > 100 &&
        this.execucao.potenciaExecucao <= 300
      ) {
        this.isCombinar2 = false;
        this.execucao.valorTotal += Number(
          (this.execucao.diasExecucao[4] * 390).toFixed(2)
        );
        this.execucao.prazo = this.execucao.diasExecucao[4];
      } else if (this.execucao.potenciaExecucao > 300) {
        this.isCombinar2 = true;
      }

      this.execucao.valorTotal = this.execucao.valorTotal.toFixed(2);
      if (!this.isCombinar2) {
        this.servicoSelecionado.valorTotal = this.execucao.valorTotal;
        this.servicoSelecionado.estado = this.estado2;
        this.servicoSelecionado.mensagem = 'Executar obra';
      } else {
        this.servicoSelecionado.estado = this.estado2;
        this.servicoSelecionado.mensagem =
          'Contato do responsável para combinar serviço';
      }
    },
    solicitarServico(index) {
      this.servicoSelecionado.observacao = this.observacao;
      this.servicoSelecionado.attachment = this.attachments[index]
        ? this.attachments[index]
        : undefined;
      switch (index) {
        case 0:
          this.servicoSelecionado.uc = this.ucProjetoHomologacao;
          break;
        case 1:
          this.servicoSelecionado.uc = this.execucao.uc;
          break;
        case 2:
          this.servicoSelecionado.uc = this.consultoria.uc;
          break;
      }
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
      Services.solicitar(this.servicoSelecionado)
        .then(() => {
          this.$notifications.notify({
            message: 'Serviço solicitado com sucesso! Aguarde o nosso contato.',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success',
            icon: 'fa fa-check'
          });
          this.observacao = undefined;
          this.attachments = [0, 0, 0];
          loader.hide();
        })
        .catch(err => {
          const message =
            _.get(err, 'response.status') === 400 &&
            _.has(err, 'response.data.message')
              ? _.get(err, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.notifyVue(
            'top',
            'center',
            'danger',
            message,
            'fa fa-exclamation-triangle'
          );
          loader.hide();
        });
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    uploadImage(index) {
      // eslint-disable-next-line no-undef
      const myWidget = cloudinary.createUploadWidget(
        {
          cloudName: 'dy8mstmqs',
          uploadPreset: 'afqwmioy',
          sources: ['local'],
          multiple: false,
          maxFiles: 1,
          apiKey: '456183971343259'
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.attachments[index] = result.info.url;
            let observacao = this.observacao;
            this.observacao = observacao + ' ';
            this.observacao = observacao;
          }
        }
      );
      myWidget.open();
    },
    deleteAttachment(index) {
      const attachmentsCopy = [...this.attachments];
      attachmentsCopy[index] = 0;
      this.attachments = attachmentsCopy;
    }
  }
};
</script>
<style>
#attachment {
  width: 7em;
  height: 7em;
}

#upload_widget {
  max-height: 30px;
}
</style>
